import { render, staticRenderFns } from "./DeliverySection.vue?vue&type=template&id=91b8037c&scoped=true&"
import script from "./DeliverySection.vue?vue&type=script&lang=js&"
export * from "./DeliverySection.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySection.vue?vue&type=style&index=0&id=91b8037c&scoped=true&lang=less&"
import style1 from "./DeliverySection.vue?vue&type=style&index=1&lang=less&"
import style2 from "./fieldSettings.css?vue&type=style&index=2&id=91b8037c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b8037c",
  null
  
)

export default component.exports